export default __webpack_public_path__ + "static/Spend less time on admin with automated timesheets@2x-a4e57a57261dd60bddc1a46b339b4f0e.png";